module.exports = __webpack_public_path__ + "img/home-bg.4bc1bfd9.jpg";